import { html } from "lit-element";
import { ModuleBase } from "./ModuleBase";

export class DrawSVGBaseModule extends ModuleBase {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	Draw(pointer) {
		const strShape = this.icon.strings.reduce(a => a);
		const canvas = this.canvas;
		fabric.loadSVGFromString(strShape, function(objects, options) {
			var obj = fabric.util.groupSVGElements(objects, options);

			if (obj.width > obj.height) {
				obj.scaleToHeight(50);
			} else {
				obj.scaleToWidth(50);
			}

			obj
				.set({ left: pointer.x, top: pointer.y })
				.setCoords();
			obj.selectable = true;
			canvas.add(obj);
			canvas.renderAll();
		});
	}

	render() {
		return html`
        	<style>
				:host {
					padding: 5px;
					cursor: pointer;
				}

				svg {
					max-height: 100%;
					max-width: 100%;
					cursor: pointer;
				}
			</style>
			<label>${this.icon}</label>`;
	}

	constructor(canvas, svg) {
		super();
		this.svg = svg;
		this.canvas = canvas;
	}
}
